export default {
    login: "touhid-imam",
    id: 22850214,
    node_id: "MDQ6VXNlcjIyODUwMjE0",
    avatar_url: "https://avatars.githubusercontent.com/u/22850214?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/touhid-imam",
    html_url: "https://github.com/touhid-imam",
    followers_url: "https://api.github.com/users/touhid-imam/followers",
    following_url: "https://api.github.com/users/touhid-imam/following{/other_user}",
    gists_url: "https://api.github.com/users/touhid-imam/gists{/gist_id}",
    starred_url: "https://api.github.com/users/touhid-imam/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/touhid-imam/subscriptions",
    organizations_url: "https://api.github.com/users/touhid-imam/orgs",
    repos_url: "https://api.github.com/users/touhid-imam/repos",
    events_url: "https://api.github.com/users/touhid-imam/events{/privacy}",
    received_events_url: "https://api.github.com/users/touhid-imam/received_events",
    type: "User",
    site_admin: false,
    name: "Touhid Imam",
    company: null,
    blog: "",
    location: null,
    email: null,
    hireable: null,
    bio: null,
    twitter_username: null,
    public_repos: 9,
    public_gists: 0,
    followers: 2,
    following: 16,
    created_at: "2016-10-15T05:03:05Z",
    updated_at: "2022-08-08T17:23:46Z"
}